/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Win_S2Inputs */

const en_wc_dl_win_s2 = /** @type {(inputs: Wc_Dl_Win_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-click the .msi and follow the setup wizard. The installer is code-signed by the publisher.`)
};

/**
* | output |
* | --- |
* | "Double-click the .msi and follow the setup wizard. The installer is code-signed by the publisher." |
*
* @param {Wc_Dl_Win_S2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_win_s2 = /** @type {((inputs?: Wc_Dl_Win_S2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Win_S2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_win_s2(inputs)
});
export { wc_dl_win_s2 as "wc.dl.win.s2" }